import React from 'react'
import TreeView from '@zippytech/react-toolkit/TreeView'
import '@zippytech/react-toolkit/TreeView/index.css'
import { Grid } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import AddCategoryModal from '../Drive/Modal/AddCategoryModal'
import DeleteCategoryModal from '../Drive/Modal/DeleteCategoryModal'

class SettingTree extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPath: 0,
            selectedId: null
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }


    nodeStyle = (nodeProps) => {
        if (nodeProps.node._id === this.state.selectedId) {
            return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
        } else {
            return { color: '#6b6b6b', fontWeight: 'normal', fontFamily: 'montserrat-normal' }
        }

    }
    async onSelectionChange(selectedMap) {
        this.setContext(selectedMap)
        this.setState({ selectedId: selectedMap.node._id ? selectedMap.node._id : null })
        const history = this.props.history;

        if (selectedMap.node && selectedMap.node.value === 'Knowledge Banks') {
            await dispatch.categories.getAllCategories()
            await dispatch.account.setSelectedCategoryAsync(selectedMap.node);
            await dispatch.community.setMainAreaContext("baseCategory");
            await dispatch.account.setIsCategoryChange(false);

            history.push(`/app/${this.props.match.params.accountId}/settings/knowledgeBank`)
        }
        else if (selectedMap.node && selectedMap.node.baseCategory) {
            await dispatch.categories.getCategoryById(selectedMap.node._id)
            await dispatch.account.setSelectedCategoryAsync(selectedMap.node);
            await dispatch.community.setMainAreaContext("category");
            await dispatch.account.setIsCategoryChange(true);
            await dispatch.account.setTreeIdFromParams({
                baseCategoryId: selectedMap.node.id,
            })

            history.push(`/app/${this.props.match.params.accountId}/settings/knowledgeBank/${selectedMap.node.id}`)
        }
        else if (selectedMap.node && selectedMap.node.category) {
            await dispatch.categories.getCategoryById(selectedMap.node._id)
            await dispatch.account.setSelectedCategoryAsync(selectedMap.node);
            await dispatch.community.setMainAreaContext("subCategory");
            await dispatch.account.setIsCategoryChange(true);
            await dispatch.account.setTreeIdFromParams({
                baseCategoryId: selectedMap.parent.node.id,
                categoryId: selectedMap.node.id,
            })

            history.push(`/app/${this.props.match.params.accountId}/settings/knowledgeBank/${selectedMap.parent.node.id}/${selectedMap.node.id}`)
        }
        else if (selectedMap.node && selectedMap.node.subCategory) {
            await dispatch.account.setSelectedCategoryAsync(selectedMap.node);
            await dispatch.community.setMainAreaContext(null);
            await dispatch.account.setIsCategoryChange(false);
            await dispatch.account.setTreeIdFromParams({
                baseCategoryId: selectedMap.parent.parent.node.id,
                categoryId: selectedMap.parent.node.id,
                subCategoryId: selectedMap.node.id,
            })

        }
        else if (selectedMap.node && selectedMap.node.value === 'Tags') {
            dispatch.account.setSelectedTag({})
            history.push(`/app/${this.props.match.params.accountId}/settings/tags`)
        }
        else if (selectedMap.node && selectedMap.node.baseTag) {
            dispatch.account.setSelectedTag(selectedMap.node)
            history.push(`/app/${this.props.match.params.accountId}/settings/tags/${selectedMap.node._id}`)
        }
        else if (selectedMap.node && selectedMap.node.tag) {
            dispatch.account.setSelectedTag(selectedMap.node)
            history.push(`/app/${this.props.match.params.accountId}/settings/tags/${selectedMap.node.parent}/${selectedMap.node._id}`)
        }
        else if (selectedMap.node && selectedMap.node.subTag) {
            dispatch.account.setSelectedTag(selectedMap.node)
        } else if (selectedMap.node && selectedMap.node.value === 'Workspaces') {

            history.push(`/app/${this.props.match.params.accountId}/settings/workspaceLevelSetting`)


        }
        else if (selectedMap.node && selectedMap.node.value === 'apikeys') {
            history.push(`/app/${this.props.match.params.accountId}/settings/apikeys`);
        }
        else if (selectedMap.node && selectedMap.node.value === 'Account Preferences') {
            history.push(`/app/${this.props.match.params.accountId}/settings/accountPreference`);
        }
        else if (selectedMap.node && selectedMap.node.value === 'General Settings') {
            history.push(`/app/${this.props.match.params.accountId}/settings/generalSetting`);
        }
        else if (selectedMap.node && selectedMap.node.value === 'Users & Sharing') {
            history.push(`/app/${this.props.match.params.accountId}/settings/usersSharing`);
        }
        else if (selectedMap.node && selectedMap.node.value === 'Privacy') {
            history.push(`/app/${this.props.match.params.accountId}/settings/privacy`);
        }
        else if (selectedMap.node && selectedMap.node.value === 'Security') {
            history.push(`/app/${this.props.match.params.accountId}/settings/security`);
        }
        else if (selectedMap.node && selectedMap.node.value === 'Payment & Purchases') {
            history.push(`/app/${this.props.match.params.accountId}/settings/paymentAndPurchases`);
        }
        else if (selectedMap.node && selectedMap.node.value === 'integrations') {
            history.push(`/app/${this.props.match.params.accountId}/settings/integrations`);
        }
        else if (selectedMap.node && selectedMap.node.value === 'consumptionDetails') {
            history.push(`/app/${this.props.match.params.accountId}/settings/consumptionDetails`);
        }
        else {
            await dispatch.account.setSelectedCategoryAsync(null);
            await dispatch.community.setMainAreaContext("OtherAccountSetting");
            await dispatch.account.setIsCategoryChange(false);


            history.push(`/app/${this.props.match.params.accountId}/settings`)
        }

    }

    setContext = (selectedMap) => {
        if (selectedMap.node && selectedMap.node.value === 'Knowledge Banks') {
            dispatch.app.setCurrentContext("acc-kb-setting");
            dispatch.community.setMainAreaContext("baseCategory");
        } else if (selectedMap.node && selectedMap.node.value === 'Workspaces') {
            dispatch.app.setCurrentContext("acc-ws-setting");
            dispatch.community.setMainAreaContext("OtherAccountSetting");
        } else {
            dispatch.app.setCurrentContext("");
            dispatch.community.setMainAreaContext("");
        }

    }

    componentWillMount() {
        dispatch.account.setIsCategoryChange(false);
        dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": this.props.match.params.accountId, accountOnly: true });
        dispatch.account.getAccountTagsTree({})
        let pathName = `/app/${this.props.match.params.accountId}/settings/`;
        if(pathName+"generalSetting"== this.props.location.pathname){
        this.setState({ selectedId: 100 }) 
        }else if(pathName+"accountPreference"== this.props.location.pathname){
        this.setState({ selectedId: 101 }) 
        }else if(pathName+"knowledgeBank"==this.props.location.pathname){
        this.setState({ selectedId: 102 })
        }else if(pathName+"workspaceLevelSetting"==this.props.location.pathname){
        this.setState({ selectedId: 103 })
        }else if(pathName+"apikeys"==this.props.location.pathname){
        this.setState({ selectedId: 104 })
        }else if(pathName+"integrations"==this.props.location.pathname){
        this.setState({ selectedId: 105 })
        }
    }

    render() {

        const treeData = [
            {
                _id: 100,
                label: "General Settings",
                value: 'General Settings'
            },
            {
                _id: 101,
                label: "Account Preferences",
                value: 'Account Preferences'
            },
            {
                _id: 102,
                label: "Knowledge Banks",
                value: 'Knowledge Banks',
                nodes: this.props.categoryTree
            },
            {
                _id: 103,
                label: "Workspaces",
                value: "Workspaces"
            },
            {
                _id: 104,
                label: "API keys",
                value: "apikeys",
            },
            {
                label: "Users & Sharing",
                disabled: true
            },
            {
                label: "Privacy",
                disabled: true
            },
            {
                label: "Security",
                disabled: true
            },
            {
                label: "Payment & Purchases",
                disabled: true

            },
            {
                _id: 105,
                label: "Integrations",
                value: "integrations",
            },
            {
                _id: 106,
                label: "Consumption Details",
                value: "consumptionDetails",
            }
        ];

        let components = [];
        const getDataNode = function (treeData, container) {
            treeData.forEach(function (treeNode) {
                if (treeNode) {
                    let dataNode = {
                        label: <span title={treeNode.label} >
                            {treeNode.label}
                        </span>
                    }
                    if (treeNode.value) {
                        dataNode.value = treeNode.value;
                    }
                    if (treeNode._id) {
                        dataNode._id = treeNode._id
                    }
                    if (treeNode.id) {
                        dataNode.id = treeNode.id
                    }
                    if (treeNode.name) {
                        dataNode.name = treeNode.name
                    }
                    if (treeNode.parent) {
                        dataNode.parent = treeNode.parent
                    }
                    if (treeNode.baseCategory) {
                        dataNode.baseCategory = treeNode.baseCategory
                    }
                    if (treeNode.category) {
                        dataNode.category = treeNode.category
                    }
                    if (treeNode.subCategory) {
                        dataNode.subCategory = treeNode.subCategory
                    }
                    if (treeNode.nodes && treeNode.nodes.length) {
                        dataNode.nodes = [];
                        getDataNode(treeNode.nodes, dataNode.nodes)
                    }
                    container.push(dataNode);
                }

            });
        }
        getDataNode(treeData, components);

        return (
            <div>
                {treeData ? <TreeView
                    leafNodeIcon={
                        <svg fill="#000000" height="16" viewBox="0 0 24 24" width="22" style={{ verticalAlign: 'middle', overflow: 'inherit' }}>
                            <path d="M 0 10 20 10" stroke="#F6F6F6" strokeWidth="1" fill="none" />
                        </svg>
                    }
                    className="browserPane"
                    enableSelection={true}
                    nodeStyle={this.nodeStyle}
                    onSelectionChange={(selectedMap) => { this.onSelectionChange(selectedMap) }}
                    dataSource={treeData}
                    singleSelect={true}
                    enableHoverStyle={false}
                    enableKeyboardNavigation={false}
                    defaultCollapsedDepth={0}
                /> : null}

                {/* {this.props.isAddCategoryModalOpen ?
                    <AddCategoryModal
                        isAddCategoryModalOpen={this.props.isAddCategoryModalOpen}
                        user={this.props.user}
                        accountId={this.props.match.params.accountId}
                        categoryType={this.props.mainAreaContext}
                        baseCategory={this.props.baseCategoriesArr}
                        categories={this.props.categoriesArr}
                        subCategories={this.props.subCategoriesArr}
                        selectedCategory={this.props.selectedCategory}
                        categoryTreeId={this.props.categoryTreeId}
                        loading={this.props.addCategoryLoader}
                        history={this.props.history}
                    />
                    : ''
                } */}

                {/* {this.props.isDeleteCategoryModalOpen ?
                    <DeleteCategoryModal
                        isDeleteCategoryModalOpen={this.props.isDeleteCategoryModalOpen}
                        user={this.props.user}
                        accountId={this.props.match.params.accountId}
                        selectedCategory={this.props.selectedCategory}
                        categoryTreeId={this.props.categoryTreeId}
                        history={this.props.history}
                        loading={this.props.deleteLoader}
                        categoryType={this.props.mainAreaContext}
                        categoryTree={this.props.categoryTree}
                    />
                    : ''
                } */}
            </div>
        );
    }
}
export default withRouter(SettingTree);
